import ItemsViewMainContent from "@features/report/components/Items/ItemsViewMainContent";
import { useDevice } from "@hooks/useDevice";
import type { BaseItemSchema } from "@memorang/types/src/session/new-session";
import Box from "@memorang/ui/src/components/Box";
import EmptyState from "@memorang/ui/src/components/EmptyView";
import ScrollContainer from "@memorang/ui/src/components/ScrollContainer";
import CustomAppbar from "components/CustomAppbar";
import { QuickActionChips } from "components/QuickActionChips";
import pluralize from "pluralize";
import { Card } from "react-native-paper";
import { usePrinting } from "../../hooks/usePrinting";
import PrintButton from "../print/PrintButton";
import PrintableReportContainer from "../print/PrintableReportContainer";
import type { ItemFilterType } from "./types";
import useItemsFilter from "./useItemsFilter";

type Props = {
	sessionItems?: BaseItemSchema[];
	isDetailView?: boolean;
};
const ItemsDetailView = ({ sessionItems, isDetailView }: Props) => {
	const {
		filters,
		handleSelectFilter,
		handleClearFilters,
		localItems,
		breadcrumbs,
		selectedFilters,
	} = useItemsFilter(sessionItems);
	const { isMobile } = useDevice();
	const { isPrintMode } = usePrinting();

	const showEmptyState = !localItems?.length;
	const description = "See your item performance based on this session";

	if (isPrintMode) {
		return <PrintableReportContainer />;
	}

	return (
		<>
			<CustomAppbar
				back
				breadcrumbs={breadcrumbs}
				options={{
					headerTitle: "Item performance",
					subtitle: isMobile ? undefined : description,
					headerRight: () => <PrintButton />,
				}}
			/>
			<Box flex={1}>
				<ScrollContainer maxWidth="sm">
					<Box paddingTop={isMobile ? 16 : 24}>
						<QuickActionChips
							quickActionsChips={filters}
							handleQuickActionPress={(filter) => {
								handleSelectFilter(filter as ItemFilterType);
							}}
						/>
					</Box>
					{showEmptyState ? (
						<EmptyState
							title="No items match your filters"
							subtitle={`Try selecting different filters or clear ${selectedFilters?.join(", ")} ${pluralize("filter", selectedFilters?.length || 0)} to see all items`}
							emptyStateOptions={[
								{
									label: "Clear all filters",
									action: handleClearFilters,
								},
							]}
						/>
					) : (
						<>
							{isMobile ? (
								<ItemsViewMainContent
									numTotalItems={localItems.length}
									localItems={localItems}
								/>
							) : (
								<Box flex={1} paddingVertical={24}>
									<Card
										style={{
											flex: 1,
										}}
									>
										<ItemsViewMainContent
											numTotalItems={localItems.length}
											localItems={localItems}
											isDetailView={isDetailView}
										/>
									</Card>
								</Box>
							)}
						</>
					)}
				</ScrollContainer>
			</Box>
		</>
	);
};

export default ItemsDetailView;
